import i18n from 'i18next'
import React, { ReactNode, useEffect, useState } from 'react'

import { defaultLanguage } from '../i18n.ts'

interface GlobalContextInterface {
  mainLanguage: string
  setMainLanguage: (lang: string) => void
  langs: { [key: string]: { nativeName: string } }
  host: string
  org: string
}

const GlobalContext = React.createContext<GlobalContextInterface>({
  mainLanguage: 'de',
  setMainLanguage: () => {},
  langs: {},
  host: '',
  org: '',
})

const getApiHost = (org: string) => {
  if (window.location.hostname.includes('localhost')) {
    return 'http://localhost:3000'
  }
  if (window.location.hostname.includes('.dev.cluster.gpt.liip.ch')) {
    return `https://${org}.api.dev.cluster.gpt.liip.ch`
  }
  if (window.location.hostname.includes('.prod.cluster.gpt.liip.ch')) {
    return `https://${org}.api.prod.cluster.gpt.liip.ch`
  }
  if (window.location.hostname.includes('.dev.genai.liip.ch')) {
    return `https://${org}.api.dev.genai.liip.ch`
  }
  if (window.location.hostname.includes('.prod.genai.liip.ch')) {
    return `https://${org}.api.prod.genai.liip.ch`
  }
  return `https://${org}-api.gpt.liip.ch`
}

export const GlobalContextProvider = ({ children }: { children: ReactNode }) => {
  const langs: { [key: string]: { nativeName: string } } = {
    en: { nativeName: 'English' },
    de: { nativeName: 'Deutsch' },
    fr: { nativeName: 'Français' },
  }
  const mainLanguageDetected = i18n.language?.split('-')[0]
  const org = import.meta.env.VITE_ORG_NAME

  const host = getApiHost(org)

  const [mainLanguage, setMainLanguage] = useState(langs[mainLanguageDetected] ? mainLanguageDetected : defaultLanguage)

  useEffect(() => {
    document.documentElement.lang = mainLanguage
  }, [mainLanguage])

  return (
    <GlobalContext.Provider value={{ mainLanguage, setMainLanguage, langs, host, org }}>
      {children}
    </GlobalContext.Provider>
  )
}
export default GlobalContext
